import { createContext } from "react";
import { ICodeEditorContext } from "@hooks/useCodeEditorOptions";

const CodeEditorContext = createContext({} as ICodeEditorContext);

export default CodeEditorContext;
